import _ from 'lodash';

const realisations = [
	{
		id: 1,
		title: 'Dallage et Assainissement à Croix',
		typeText: 'Maçonnerie/dallage BA',
		types: ['1'],
		annee: '2018',
		media: {
			directory: 'realisations/croixDallageAssainissement/',
			images: [
				{
					name: '1.jpg',
				},
				{
					name: '2.jpg',
				},
				{
					cover: true,
					name: '3.png',
				},
				{
					name: '4.jpg',
				}
			]
		}
	},
	{
		id: 2,
		title: 'Portail à Ennetieres',
		typeText: 'Portail',
		types: ['2'],
		annee: '2018',
		media: {
			directory: 'realisations/ennetieresPortail/',
			images: [
				{
					cover: true,
					name: '1.jpg',
				},
				{
					name: '2.jpg',
				}
			]
		}
	},
	{
		id: 3,
		title: 'Portail à Flêtre',
		typeText: 'Portail',
		types: ['2'],
		annee: '2018',
		media: {
			directory: 'realisations/fletrePortail/',
			images: [
				{
					name: '1.png',
				},
				{
					name: '2.png',
				},
				{
					name: '3.png',
				},
				{
					name: '4.png',
				},
				{
					name: '5.png',
				},
				{
					cover: true,
					name: '6.png',
				},
				{
					name: '7.png',
				},
				{
					name: '8.png',
				},
				{
					name: '9.png',
				}
			]
		}
	},
	{
		id: 4,
		title: 'Amenagement extérieur à Merris',
		typeText: 'Aménagement extérieur',
		types: ['3'],
		annee: '2018',
		media: {
			directory: 'realisations/merrisAmenagement/',
			images: [
				{
					cover: true,
					name: '1.jpg',
				}
			]
		}
	},
	{
		id: 5,
		title: 'Amenagement et Ponton en bois exotique à Merris',
		typeText: 'Aménagement extérieur',
		types: ['3'],
		annee: '2018',
		media: {
			directory: 'realisations/merrisAmenagementPontonBoisExotique/',
			images: [
				{
					name: '1.jpg',
				},
				{
					name: '2.jpg',
				},
				{
					name: '3.jpg',
				},
				{
					name: '4.jpg',
				},
				{
					name: '5.jpg',
				},
				{
					name: '6.jpg',
				},
				{
					name: '7.jpg',
				},
				{
					name: '8.jpg',
				},
				{
					cover: true,
					name: '9.jpg',
				},
				{
					name: '10.jpg',
				},
				{
					name: '11.jpg',
				}
			]
		}
	},
	{
		id: 6,
		title: 'Dallage à Sequedin',
		typeText: 'Maçonnerie/dallage BA',
		types: ['1'],
		annee: '2018',
		media: {
			directory: 'realisations/sequedinDallage/',
			images: [
				{
					cover: true,
					name: '1.jpg',
				}
			]
		}
	}
]

export function getRealisations() {
	return realisations
}

export function getRealisation(id) {
	return _.filter(realisations, (real) => real.id == id)
}



// WEBPACK FOOTER //
// ./src/actions/realisationsData.js